module.exports = __webpack_public_path__ + "static/media/facebook-post.8da1014d.png";